import type { ComponentDocMap } from './types'

/**
 * Prop documentation for the `excel_button` component.
 * Keep in sync with ExcelButtonProps in src/ui/uiConfig/components/ExcelButton/ExcelButton.types.ts
 */
export const excelButtonPropDocs: ComponentDocMap = {
  tabs: {
    description: 'Sheet export configuration. One entry equals one sheet in the resulting workbook.',
    type: 'DatasetExport[]',
    example: '[{ ui_config_id: 42, title: "__Production", show_times_in_utc: true }]',
  },
  'tabs[].ui_config_id': {
    description: 'UI config ID whose resolved datasets should be exported.',
    type: 'number',
    example: '42',
  },
  'tabs[].title': {
    description: 'Sheet name in the Excel workbook.',
    type: 'string',
    example: '"__Production"',
  },
  'tabs[].dataset_instructions': {
    description: 'Optional explicit DSIs for this sheet. Overrides DSIs from ui_config_id.',
    type: 'DatasetInstruction[]',
    example: '[{ type: "dbs", return_id: "value" }]',
  },
  'tabs[].defaultTimeFormat': {
    description: 'Default timestamp format for this sheet if time_format is not provided.',
    type: 'string',
    example: '"YYYY-MM-DD HH:mm"',
  },
  'tabs[].overrideAlias': {
    description: 'Alias overrides applied when loading the source UI config for this sheet.',
    type: 'UiConfigAliases',
    example: '{ "opt_job_type_id": 4 }',
  },
  'tabs[].overrideProps': {
    description: 'Prop overrides applied when loading the source UI config for this sheet.',
    type: 'UiConfigProps',
    example: '{ "title": "__Override title" }',
  },
  'tabs[].show_times_in_utc': {
    description: 'Exports timestamps in UTC instead of local time.',
    type: 'boolean',
    example: 'true',
  },
  'tabs[].time_format': {
    description: 'Custom timestamp format for this specific sheet.',
    type: 'string',
    example: '"DD.MM.YYYY HH:mm"',
  },
  defaultTimeFormat: {
    description: 'Fallback timestamp format for all tabs without a tab-specific override.',
    type: 'string',
    example: '"YYYY-MM-DD HH:mm"',
  },
  title: {
    description: 'Button label when style is `button`.',
    type: 'string',
    example: '"__Export"',
  },
  style: {
    description: 'Visual variant for the export trigger.',
    type: '"button" | "icon"',
    example: '"button"',
  },
  datasetCreatedAt: {
    description: 'Optional createdAt value used for server-side dataset filtering.',
    type: 'string',
    example: '"2026-03-15T12:00:00Z"',
  },
  datasetCreatedAtOperator: {
    description: 'Comparison operator used together with datasetCreatedAt.',
    type: 'DatasetCreatedAtOperators',
    example: '"lte"',
  },
  disable_button_in_future: {
    description: 'Disables export when current selected time range is in the future.',
    type: 'boolean',
    example: 'true',
  },
}
